/**
 * PORTED — RO-3-00 / #44398.
 * Origin: THREE files, merged deliberately —
 *   `excellent/app/finance/kinds.ts`                                  (FINANCE_KINDS)
 *   `excellent/app/customers/kinds.ts`                                (CUSTOMERS_KINDS)
 *   `excellent/app/projects/[projectSlug]/[sectionSlug]/_hiring/kinds.ts` (HIRING_KINDS)
 *
 * ── Why these three become one file, when everything else in this tree is 1:1 ──
 *
 * Each original is a single `as const` array whose file-level comment says the
 * SAME thing: "kept in a plain (non-`use client`) module so BOTH the server row
 * builder and the client `ObjectsIndexClient` can import the same source of truth
 * — a `const` exported from a `use client` module reads as undefined when
 * imported by a server component."
 *
 * That reason is an RSC artifact. This host has no server components, so three
 * files exist here for a constraint that does not. Merging them is the only place
 * in this slice where the port is not byte-for-byte, and it is recorded here
 * rather than left for a reader to notice. The three arrays' VALUES are unchanged.
 */

/** Finance's Golden-Schema entity kinds (UI-UX-PATTERNS-PRD Issue 20). */
export const FINANCE_KINDS = ["money_account", "transaction"] as const;

/**
 * Customers' Golden-Schema entity kinds (Issue 20, #43439 rollout). Mirrors the
 * PRD's own example: "Customers shows/imports its people/organizations/accounts
 * rows in-page."
 */
export const CUSTOMERS_KINDS = ["lead", "person", "organization"] as const;

/**
 * Hiring's Golden-Schema entity kind. Just `person` — the Hiring PRD invariant is
 * Candidates ARE people (no separate "candidate" table), so the raw-data cut for
 * that page is the same `person` kind Customers shares.
 */
export const HIRING_KINDS = ["person"] as const;
